<template>
  <div>
    <v-dialog v-model="isOpen" @input="close" max-width="700px">
      <v-card>
        <v-card-title>{{ $t("crm.add_carrier_and_driver") }}</v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid">
            <v-card-title>{{ $t("crm.carrier_details") }}</v-card-title>
            <v-row>
              <div v-if="false">
                <!-- This block will not render -->
                <v-col cols="12" v-if="previousOrganizations.length > 0">
                  <v-autocomplete
                    :items="previousOrganizations"
                    :label="$t('crm.previous_organizations')"
                    :item-text="(item) => item.name"
                    item-value="id"
                    outlined
                    required
                    @change="onAutofillOrganization"
                  >
                    <template v-slot:item="data">
                      <div style="color: black">
                        <div>
                          <b>{{ data.item.name }}</b>
                        </div>
                        <div>
                          <span v-if="data.item.street">
                            , {{ data.item.street }}
                          </span>
                          <span v-if="data.item.postalCode">
                            , {{ data.item.postalCode }}</span
                          >
                          <span v-if="data.item.place">
                            , {{ data.item.place }}</span
                          >
                          <span v-if="data.item.countryCode">
                            , {{ data.item.countryCode }}</span
                          >
                        </div>
                      </div>
                    </template>
                  </v-autocomplete>
                </v-col>
              </div>

              <div v-if="false">
                <!-- This block will not render -->
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="form.carrierName"
                    :label="$t('crm.tbl_name')"
                    :rules="[rules.required]"
                    outlined
                    :disabled="
                      isAutofillOrganization &&
                      !(canFillEmptyFields && !form.carrierName)
                    "
                  />
                </v-col>
              </div>

              <v-col cols="12" sm="6">
                <v-combobox
                  v-model="selectedOrganization"
                  :items="previousOrganizations"
                  item-text="name"
                  :label="$t('crm.tbl_name')"
                  :rules="[rules.required]"
                  outlined
                  clearable
                  hide-no-data
                  hide-selected
                  :filter="filterOrganizations"
                  @change="onCarrierChange"
                  :readonly="
                    selectedOrganization &&
                    typeof selectedOrganization === 'object'
                  "
                >
                  <template v-slot:item="data">
                    <div>
                      <b>{{ data.item.name }}</b>
                    </div>
                    <div>
                      <span v-if="data.item.street">
                        , {{ data.item.street }}
                      </span>
                      <span v-if="data.item.postalCode">
                        , {{ data.item.postalCode }}</span
                      >
                      <span v-if="data.item.place">
                        , {{ data.item.place }}</span
                      >
                      <span v-if="data.item.countryCode">
                        , {{ data.item.countryCode }}</span
                      >
                    </div>
                  </template>
                </v-combobox>
              </v-col>

              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="form.carrierCode"
                  :label="$t('crm.carrierCode')"
                  outlined
                  :disabled="
                    isAutofillOrganization &&
                    !(canFillEmptyFields && !form.carrierCode)
                  "
                />
              </v-col>

              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="form.street"
                  :label="$t('crm.tbl_street')"
                  outlined
                  :disabled="
                    isAutofillOrganization &&
                    !(canFillEmptyFields && !form.street)
                  "
                />
              </v-col>

              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="form.place"
                  :label="$t('crm.tbl_place')"
                  outlined
                  :disabled="
                    isAutofillOrganization &&
                    !(canFillEmptyFields && !form.place)
                  "
                />
              </v-col>

              <v-col cols="6">
                <v-text-field
                  v-model="form.postalCode"
                  :label="$t('crm.postal_code')"
                  outlined
                  :disabled="
                    isAutofillOrganization &&
                    !(canFillEmptyFields && !form.postalCode)
                  "
                />
              </v-col>

              <v-col cols="6">
                <v-autocomplete
                  :items="countryList"
                  :label="$t('crm.country_code')"
                  :item-text="(item) => item.code + ' - ' + item.name"
                  item-value="code"
                  v-model="form.countryCode"
                  outlined
                  required
                  :rules="[rules.required]"
                  :error-messages="errorMessagesCountryCode"
                  :disabled="
                    isAutofillOrganization &&
                    !(canFillEmptyFields && !form.countryCode)
                  "
                />
              </v-col>

              <v-col cols="12">
                <v-text-field
                  v-model="form.VAT"
                  :label="$t('organization.vat')"
                  outlined
                  :disabled="
                    isAutofillOrganization && !(canFillEmptyFields && !form.VAT)
                  "
                />
              </v-col>
            </v-row>

            <v-card-title>{{ $t("crm.driver_details") }}</v-card-title>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="form.phone"
                  :label="$t('user.phone')"
                  :rules="[rules.required, rules.phone]"
                  placeholder="+49123456789"
                  outlined
                  @blur="fetchDriverByPhone"
                />
              </v-col>

              <v-col cols="6">
                <v-text-field
                  v-model="form.driverFirstName"
                  :label="$t('user.name')"
                  :rules="[rules.required]"
                  outlined
                />
              </v-col>

              <v-col cols="6">
                <v-text-field
                  v-model="form.driverLastName"
                  :label="$t('user.surname')"
                  :rules="[rules.required]"
                  outlined
                />
              </v-col>

              <v-col cols="12">
                <v-text-field
                  v-model="form.email"
                  :label="$t('user.email')"
                  :rules="[rules.email]"
                  outlined
                />
              </v-col>

              <v-col cols="6">
                <v-text-field
                  v-model="form.licensePlateTruck"
                  :label="$t('crm.license_plate_truck')"
                  :rules="[rules.required]"
                  outlined
                />
              </v-col>

              <v-col cols="6">
                <v-text-field
                  v-model="form.licensePlateTrailer"
                  :label="$t('crm.license_plate_trailer')"
                  outlined
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="close">{{ $t("crm.cancel") }}</v-btn>
          <v-btn color="primary" text @click="validateAndOpenConfirm">{{
            $t("crm.send_to_driver")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmDialog" max-width="500px">
      <v-card>
        <v-card-title class="headline">{{
          $t("crm.confirm_before_send")
        }}</v-card-title>
        <v-card-text>
          {{ $t("crm.confirmation_responsibility_message") }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="confirmDialog = false">{{
            $t("crm.cancel")
          }}</v-btn>
          <v-btn color="primary" text @click="confirmAndSubmit">{{
            $t("crm.confirm")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="autofillDialog" max-width="500px">
      <v-card>
        <v-card-title class="headline">{{
          $t("crm.fill_driver_info_prompt")
        }}</v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="autofillDialog = false">{{
            $t("crm.cancel")
          }}</v-btn>
          <v-btn color="primary" text @click="onAutofillDriverInfo">{{
            $t("crm.confirm")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :timeout="0" top color="white" text>
      <p :style="{ color: snackbarColor }">
        {{ text }}
      </p>

      <template>
        <v-btn
          :color="snackbarColor"
          variant="text"
          outlined
          @click="snackbar = false"
        >
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import config from "../../config";
import Axios from "axios";

export default {
  name: "SpotCharterDialog",
  props: {
    open: { type: Boolean, required: true },
    selectedCmrList: { type: Array, required: true },
  },
  created() {
    this.loadCountries();
    this.fetchPreviousOrganizations();

    this.isOpen = this.open;
  },
  data() {
    return {
      snackbar: false,
      text: "test",
      snackbarColor: "#ff9800",
      valid: true,
      confirmDialog: false,
      autofillDialog: false,
      isOpen: false,
      autofillDriverInfo: {
        name: "",
        surname: "",
        email: "",
      },
      previousOrganizations: [],
      selectedOrganization: null,
      selectedItem: null,
      canFillEmptyFields: true,
      isAutofillOrganization: false,
      form: {
        carrierName: "",
        street: "",
        place: "",
        postalCode: "",
        countryCode: "",
        carrierCode: "",
        VAT: "",
        driverFirstName: "",
        driverLastName: "",
        phone: "",
        email: "",
        licensePlateTruck: "",
        licensePlateTrailer: "",
        notificationType: 2, // Default to WhatsApp
      },
      notificationOptions: [
        { text: "SMS", value: 1 },
        { text: "WhatsApp", value: 2 },
      ],
      rules: {
        required: (v) => !!v || "Required",
        email: (v) => !v || /.+@.+\..+/.test(v) || "Invalid email",
        phone: (v) => /^\+\d{7,15}$/.test(v) || "Invalid phone (E.164 format)",
      },
    };
  },
  watch: {
    open(newVal) {
      this.isOpen = newVal;
    },
  },

  methods: {
    onAutofillOrganization(value) {
      const selectedItem = this.previousOrganizations.find(
        (item) => item.id === value
      );
      if (!selectedItem) return;

      this.isAutofillOrganization = true;
      this.canFillEmptyFields = selectedItem.canFillEmptyFields;

      this.form.carrierName = selectedItem.name || "";
      this.form.street = selectedItem.street || "";
      this.form.place = selectedItem.place || "";
      this.form.postalCode = selectedItem.postalCode || "";
      this.form.countryCode = selectedItem.countryCode || "";
      this.form.carrierCode = selectedItem.carrierCode || "";
      this.form.VAT = selectedItem.vat || "";
    },

    filterOrganizations(item, queryText) {
      if (!queryText) return true;
      const text = queryText.toLowerCase();
      return item.name.toLowerCase().includes(text);
    },

    onCarrierChange(selected) {
      if (selected && typeof selected === "object") {
        this.isAutofillOrganization = true;
        this.canFillEmptyFields = selected.canFillEmptyFields;
        this.selectedItem = selected;

        this.form.carrierName = selected.name || "";
        this.form.street = selected.street || "";
        this.form.place = selected.place || "";
        this.form.postalCode = selected.postalCode || "";
        this.form.countryCode = selected.countryCode || "";
        this.form.carrierCode = selected.carrierCode || "";
        this.form.VAT = selected.vat || "";
      } else if (typeof selected === "string") {
        this.isAutofillOrganization = false;
        this.canFillEmptyFields = true;
        this.selectedItem = null;

        this.form.carrierName = selected || "";
      } else {
        this.isAutofillOrganization = false;
        this.canFillEmptyFields = true;
        this.selectedItem = null;

        this.form.carrierName = "";
      }
    },

    onAutofillDriverInfo() {
      this.form.driverFirstName = this.autofillDriverInfo.name || "";
      this.form.driverLastName = this.autofillDriverInfo.surname || "";
      this.form.email = this.autofillDriverInfo.email || "";
      this.autofillDialog = false;
    },
    async fetchPreviousOrganizations() {
      try {
        const response = await Axios.get(
          `${config.apiBaseUrl}api/Organization/spot-charter-list`,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("accessToken"),
            },
          }
        );

        if (response.data) {
          this.previousOrganizations = response.data;
        }
      } catch {
        //
      }
    },
    async fetchDriverByPhone() {
      const phone = this.form.phone;

      if (!this.rules.phone(phone)) return;

      const formData = new FormData();

      formData.append("phone", phone);

      try {
        const response = await Axios.post(
          `${config.apiBaseUrl}api/Employee/driver-by-phone`,
          formData,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("accessToken"),
            },
          }
        );

        const driver = response.data;
        if (driver) {
          this.autofillDialog = true;
          this.autofillDriverInfo = {
            ...driver,
          };
        }
      } catch {
        // optionally show a message
      }
    },
    validateAndOpenConfirm() {
      const formValid = this.$refs.form.validate();
      if (formValid) {
        this.confirmDialog = true;
      }
    },
    loadCountries() {
      this.$store.dispatch("GET_COUNTRIES").then(() => {
        this.countryList = this.$store.getters.COUNTRIES_LIST.map((item) => ({
          code: item.code,
          name: item.name,
        }));
      });
    },
    close() {
      this.$emit("onClose", false);
    },
    async confirmAndSubmit() {
      this.confirmDialog = false;
      await this.submitForm();
    },
    async submitForm() {
      const formValid = this.$refs.form.validate();
      if (!formValid) return;

      const formData = new FormData();
      formData.append(
        "cmrIdList",
        this.selectedCmrList.map((cmr) => cmr.id).join(",")
      );

      for (const key in this.form) {
        formData.append(key, this.form[key]);
      }

      try {
        const response = await Axios.post(
          config.apiBaseUrl + "api/cmr/create-spot-charter",
          formData,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("accessToken"),
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        this.form = {
          carrierName: "",
          street: "",
          place: "",
          postalCode: "",
          countryCode: "",
          carrierCode: "",
          VAT: "",
          driverFirstName: "",
          driverLastName: "",
          phone: "",
          email: "",
          licensePlateTruck: "",
          licensePlateTrailer: "",
          notificationType: null,
        };

        if (response.status === 201) {
          this.snackbarColor = "#ff9800";
          this.snackbar = true;
          this.text = this.$t("crm.spot_charter_success");
        }

        this.close();
      } catch (error) {
        this.snackbarColor = "#ff5252";
        this.snackbar = true;
        this.text = error.message;
      }
    },
  },
};
</script>
